export const BREAKPOINTS_TO_FILL = ['largeMobile', 'tablet', 'desktop', 'wide'] as const;
export const BREAKPOINTS = ['mobile', ...BREAKPOINTS_TO_FILL] as const;

export type BreakpointToFill = typeof BREAKPOINTS_TO_FILL[number];
export type Breakpoint = typeof BREAKPOINTS[number];
